// extracted by mini-css-extract-plugin
export var TitleModule = "ElevatedTitleCentered-module--TitleModule--1rMqt";
export var inner = "ElevatedTitleCentered-module--inner--ynvhC";
export var innerWithBackground = "ElevatedTitleCentered-module--innerWithBackground--1PemR";
export var heading = "ElevatedTitleCentered-module--heading--u4ZAN";
export var tagline = "ElevatedTitleCentered-module--tagline--3BL3J";
export var linkText = "ElevatedTitleCentered-module--linkText--1z1uk";
export var ctaContainer = "ElevatedTitleCentered-module--ctaContainer--1L2nG";
export var textCtaContainer = "ElevatedTitleCentered-module--textCtaContainer--1SEAT";
export var backgroundImg = "ElevatedTitleCentered-module--backgroundImg--JxEo0";